import { useMemo, useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';

export function useExpandedBatches(key: string) {
  // Store as array in localStorage because Set cannot be stringified directly
  const [storedBatches, setStoredBatches] = useLocalStorage<number[]>(key, []);

  // Expose as Set for the component to maintain compatibility with existing code
  const expandedBatches = useMemo(() => new Set(storedBatches), [storedBatches]);

  // Custom setter to handle Set -> Array conversion
  const setExpandedBatches = useCallback((value: Set<number> | ((prev: Set<number>) => Set<number>)) => {
    setStoredBatches((prevArray) => {
      const prevSet = new Set(prevArray);
      const newSet = value instanceof Function ? value(prevSet) : value;
      return Array.from(newSet);
    });
  }, [setStoredBatches]);

  return [expandedBatches, setExpandedBatches] as const;
}
